<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-row align="center" justify="center">
                    <div class="text-center subtitle-1">
                        <span
                            v-html="$t('Печать счёта-квитанции за период по адресу', { period: billPeriod, address: accountAddress })"
                        ></span>
                    </div>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="6" md="2">
                        <div class="text-center">
                            <v-btn
                                rounded
                                color="teal darken-4"
                                dark
                                :disabled="!formValid"
                                @click="save()"
                            >{{$t('Сохранить PDF')}}</v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <div class="text-center">
                            <v-btn
                                rounded
                                color="teal darken-4"
                                dark
                                :disabled="!formValid"
                                @click="print()"
                            >{{$t('Распечатать')}}</v-btn>
                        </div>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <div class="text-center">
                        <h3>{{ message }}</h3>
                    </div>
                </v-row>
            </v-col>
        </v-row>
        <v-row align="center" justify="center">
            <div v-if="isProcessing" class="text-center">
                <v-progress-circular :size="100" indeterminate color="teal"></v-progress-circular>
            </div>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import printJS from 'print-js';
import filesave from 'file-saver';

export default {
    components: {},
    data() {
        return {
            formValid: true,
            message: ''
        };
    },
    computed: {
        ...mapState('print', ['accountData', 'billPDF', 'billForming']),
        ...mapGetters('print', ['billPDFFileName']),
        accountAddress() {
            return this.accountData.account_address;
        },
        isProcessing() {
            return this.billForming;
        },
        billPeriod() {
            return `${this.$t(this.accountData.billPeriod)} ${this.accountData.bill_year}`;
        }
    },
    watch: {
        inputedText() {
            this.message = '';
        }
    },
    methods: {
        ...mapActions('print', ['loadBillPDFBase64', 'loadBillPDF', 'getAccountId']),
        routeIfNoAccountData() {
            if (this.accountData.account_f_id === -1) {
                this.$router.push('/');
            }
        },
        async print() {
            try {
                let recaptchaToken = await this.recaptcha('/getBillPDFAsBase64');
                let checkAccountResult = await this.getAccountId({ recaptchaToken: recaptchaToken });
                if (checkAccountResult === 'OK') {
                    await this.loadBillPDFBase64(recaptchaToken);
                    printJS({ printable: this.billPDF, type: 'pdf', base64: true });
                } else this.message = checkAccountResult;
            } catch (error) {
                this.message = this.$t('Извините, произошла ошибка');
            }
        },
        async save() {
            try {
                let recaptchaToken = await this.recaptcha('/getBillPDF');
                let checkAccountResult = await this.getAccountId({ recaptchaToken: recaptchaToken });
                if (checkAccountResult === 'OK') {
                    await this.loadBillPDF(recaptchaToken);
                    filesave.saveAs(this.billPDF, this.billPDFFileName);
                } else this.message = checkAccountResult;
            } catch (error) {
                this.message = this.$t('Извините, произошла ошибка');
            }
        },
        async recaptcha(action) {
            let token = await this.$recaptcha(action);
            return token;
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.routeIfNoAccountData();
            next();
        });
    }
};
</script>
